import { render, staticRenderFns } from "./news-section.vue?vue&type=template&id=627063c1&scoped=true&"
import script from "./news-section.vue?vue&type=script&lang=js&"
export * from "./news-section.vue?vue&type=script&lang=js&"
import style0 from "./news-section.vue?vue&type=style&index=0&id=627063c1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627063c1",
  null
  
)

export default component.exports